import i18n from 'src/i18n'
// Bind helpers
export default {
  install(Vue) {
    Vue.t = i18n.t.bind(i18n)
  }
}
